import Invite from './Invite.vue';

export default Invite;



// WEBPACK FOOTER //
// ./src/pages/invite/index.ts